var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4158 1.24023C18.9858 1.24023 19.4158 1.74023 19.1858 2.67023L16.3958 15.8202C16.2008 16.7552 15.6358 16.9802 14.8558 16.5452L8.20078 11.6302C8.17497 11.6117 8.15394 11.5873 8.13944 11.5591C8.12493 11.5308 8.11737 11.4995 8.11737 11.4677C8.11737 11.436 8.12493 11.4047 8.13944 11.3764C8.15394 11.3481 8.17497 11.3238 8.20078 11.3052L13.8858 6.36523C14.2358 6.05523 13.8108 5.90523 13.3508 6.18523L5.70578 10.2702C5.67653 10.2893 5.64331 10.3015 5.60866 10.3058C5.57401 10.3101 5.53882 10.3065 5.50578 10.2952L1.41078 9.00023C0.500777 8.73523 0.500777 8.11023 1.61578 7.66523L18.0008 1.34523C18.1307 1.28289 18.2718 1.24719 18.4158 1.24023Z",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.a36cfefd24a6e18daaf9f5dcd0e90be9.svg";
export { ForwardRef as ReactComponent };